import React, { useContext } from "react";
import AddButton from "./AddButton";
import Price from "./Price.jsx";
import CartContext from "../../context/CartContext";
import PopupContext from "../../context/PopupContext";
import SearchContext from "../../context/SearchContext";
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';


const ProductItem = ({ product, isListView }) => {
  const cartCtx = useContext(CartContext);
  const searchCtx = useContext(SearchContext);
  const popupCtx = useContext(PopupContext);
  const handleAddItem = () => {
    cartCtx.addItem(product);
  };

  const handleRemoveItem = () => {
    cartCtx.removeItem(product.id);
  };

  return (
    <>
      <div className={` ${isListView ? 'list-item' : 'grid-item product-item'}`} key={product.id}>

        {isListView ? (
          <>
            <TableRow
              key={product.id}
              className="productItem product-row"
            >
              <TableCell
                className="cell-image cell-content-center"
              >
                {product.image && (
                  <img
                    src={product.image}
                    alt={product.productname}
                    className="product-img"
                    onClick={() => {
                      if (!searchCtx.isSearchEnabel) {
                        popupCtx.openProductPopup(product);
                      }
                    }}
                  />
                )}
              </TableCell>

              <TableCell
                className="cell-name"
                style={{ textAlign: 'left', height: '-webkit-fill-available' }}
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '4px',
                  justifyContent: 'flex-start',
                  flexWrap: 'nowrap',
                }}>
                  <div
                    style={{
                      maxWidth: 'max-content',
                      overflow: 'hidden',
                    }}
                    dangerouslySetInnerHTML={{ __html: product.productname }}
                  />
                  <span style={{ fontSize: '0.85em', color: '#666' }}>
                    (#{product.code})
                  </span>
                </div>
              </TableCell>

              <TableCell
                className="cell-price cell-content-center"
              >
                <div className="price-stack">
                  <div className="special-price">₹{product.specialprice || product.price}</div>
                  <strike className="original-price">₹{product.price}</strike>
                </div>
              </TableCell>

              <TableCell
                className="cell-action cell-content-center"
              >
                <AddButton
                  qty={product.qty}
                  add={handleAddItem}
                  remove={handleRemoveItem}
                  isListView={isListView}
                />
              </TableCell>
            </TableRow>
          </>

        ) : (
          <>
            <div className="p-left">
              <div className="p-name"><div dangerouslySetInnerHTML={{ __html: product.productname }} /></div>
              <Price
                spacialPrice={product.specialprice}
                finalPrice={product.price}
              />
              <span className="sku">#{product.code}</span>
            </div>
            <div className={`p-right ${product.image ? "" : "without-img"}`}>
              {product.image && (
                <div className="img-box">
                  <img
                    src={product.image}
                    alt={product.productname}
                    onClick={() => { !searchCtx.isSearchEnabel && popupCtx.openProductPopup(product) }}
                  />
                </div>
              )}
              <AddButton
                qty={product.qty}
                add={handleAddItem}
                remove={handleRemoveItem}
              />
            </div>
          </>
        )}

      </div >

    </>
  );
};

export default ProductItem;